import { z } from "zod/v4"
import { DocumentSnapshotLike } from "../firestore"
import { LiveReactionId, LiveReactionIdSchema } from "../id"
import { CreatedAt, UpdatedAt } from "./system"
import { AggregatedReactionCounts } from "./live-comment"

/**
 * ライブのリアクション（raw reaction）
 * 
 * クライアントから送信されたリアクションのカウントを一時的に保存するためのドキュメント。
 * 集約デーモンによって定期的に集約され、comments コレクションに集約ドキュメントとして書き込まれる。
 * 
 * パス: /spaces/{spaceKey}/lives/{liveId}/live-reactions/{reactionId}
 */

export const LiveReactionDocumentBody = z.object({
  counts: AggregatedReactionCounts,
  created_at: CreatedAt,
  updated_at: UpdatedAt,
})

export type LiveReactionDocumentBody = z.infer<typeof LiveReactionDocumentBody>

export const LiveReactionDocument = z.intersection(
  LiveReactionDocumentBody,
  z.object({
    id: LiveReactionIdSchema,
  })
)

export type LiveReactionDocument = z.infer<typeof LiveReactionDocument>

export class LiveReactionDocuments {
  static toDocumentData(doc: LiveReactionDocument): object {
    return {
      ...doc,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): LiveReactionDocument | null {
    if (!doc) {
      return null
    }

    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: LiveReactionId(doc.id),
      counts: data["counts"] as AggregatedReactionCounts,
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}

export const CreateLiveReactionRequest = z.object({
  counts: AggregatedReactionCounts,
})

export type CreateLiveReactionRequest = z.infer<typeof CreateLiveReactionRequest>
